function Header (props) {
    return (
        <>
        <div className='print-no rahpardaznet-cart-header'>
            {props.title}
        </div>
        </>
    )
}

export default Header;